<template>
<div class="box">
	<div class="box__container">
		<div class="box__header">
			<div class="box__header__title">
			<h2>{{ 'greeting' | translate | capitalize }}</h2>
			</div>
			<div class="box__header__edit" @click="toggleEditProfile">
				<p>{{ 'edit' | translate | capitalize }}</p>
			</div>
		</div>
		<div class="box__body">
			<div class="box__body__subtitle">
			<p>{{ 'greeting-title' | translate | capitalize }}</p>
			</div>
				<form @submit.prevent="grettingRegister" class="form-content" id="greet">
				<div class="form__group form__group-relative">
					<label for="name">{{ 'facebook-greeting' | translate | capitalize }}</label>
					<textarea id="greeting-facebook" maxlength="1000" @input="count($event, 1000)" v-model="greeting.on_facebook" required :disabled="!this.toggleEdit"></textarea>
					<span id="counter-greeting-facebook" class="label pull-right bg-red counter"></span>
				</div>
				<div class="form__group form__group-relative">
					<label for="name">{{ 'website-greeting' | translate | capitalize }}</label>
					<textarea id="greeting-website" maxlength="1000" @input="count($event, 1000)" v-model="greeting.on_website" required :disabled="!this.toggleEdit"></textarea>
					<span id="counter-greeting-website" class="label pull-right bg-red counter"></span>
				</div>
				<div class="form__group">
					<div class="has-error" v-show="error.form_error">
					<label class="control-label" for="email"><i class="fas fa-times-circle-o"></i>{{ 'required-field' | translate | capitalize }}</label>
					</div>
				</div>
				<div class="form__group submit__content" v-if="this.toggleEdit">
					<button type="submit" :aria-busy="submitLoading ? 'true' : 'false'">
						{{ 'save' | translate | capitalize }}
					</button>
					<div class="alert__success" v-show="successMsg">
						<template class="control-label">
							{{ 'save-with-success' | translate | capitalize }}
						</template>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>
</template>
<script>
export default {
	name: 'greeting',
	data() {
		return {
			greetingForm: {
				obj: {},
				greeting_id: '',
			},
			userdata: {},
			erro: false,
			successMsg: false,
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
			submitLoading: false,
			toggleEdit: false,
		};
	},
	computed: {
		error() {
			return this.$store.state.error;
		},
		success() {
			return this.$store.state.status;
		},
		greeting() {
			return this.$store.state.profile.greeting;
		},
	},
	watch: {
		user() {
			this.userdata = this.$store.state.user;
		},
	},
	methods: {
		toggleEditProfile() {
			this.toggleEdit = !(this.toggleEdit);
		},
		toggleSubmitLoading() {
			this.submitLoading = !this.submitLoading;
		},
		count(event, tam) {
			const lengthText = document.getElementById(`counter-${event.target.id}`);
			lengthText.textContent = (event.target.value.length - tam) * -1;
		},
		grettingRegister() {
			if (this.greeting.on_facebook) {
				this.erro = false;
				const payload = {
					on_facebook: this.greeting.on_facebook,
					on_website: this.greeting.on_website,
				};
				this.toggleSubmitLoading();
				this.$store.dispatch('setGreeting', payload)
					.then(() => {
						this.toggleSubmitLoading();
						this.successMsg = this.success;
						// setTimeout(() => {
						// 	this.successMsg = false;
						// }, 5000);
					})
					.catch(() => {
						this.toggleSubmitLoading();
					});
			} else {
				this.erro = true;
			}
		},
		errorForm(obj, field) {
			let erro = false;
			if (obj) {
				if (obj[field]) {
					erro = true;
				}
			}
			return erro;
		},
		validate() {
			if (this.success) {
				this.successMsg = this.success;
			}
		},
		collapsePainel(event) {
			$.AdminLTE.boxWidget.collapse($(event.target));
		},
		valueGreeting() {
			this.greetingForm.greeting_id = sessionStorage.getItem('greetingSelected');
		},
		fixStringOption(option, user) {
			/* eslint-disable */
			let opt = '';
			if (this.user) {
			opt = option.content.replace('${user.office.name}', user.office.name).replace('${user.name}', user.name);
			}
			return opt;
		},
	},
	mounted() {
		this.$store.dispatch('getGreeting', this.session);
	},
};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/profile/greeting.vue